import * as React from "react";
import type { SVGProps } from "react";
const SvgSchool = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#school_svg__a)">
      <path d="M22 16c-.55 0-1-.45-1-1v-4.52l-8.63 3.45c-.24.1-.5.1-.74 0l-10-4a1 1 0 0 1 0-1.86l10-4c.24-.1.5-.1.74 0l10 4s.03.01.04.02a1 1 0 0 1 .53.56c.04.12.07.24.06.37V15c0 .55-.45 1-1 1M4.69 9 12 11.92 19.31 9 12 6.08z" />
      <path d="M12 20c-3.99 0-7-1.72-7-4v-5.4c0-.55.45-1 1-1s1 .45 1 1V16c0 .82 1.95 2 5 2s5-1.18 5-2v-5.4c0-.55.45-1 1-1s1 .45 1 1V16c0 2.28-3.01 4-7 4" />
    </g>
    <defs>
      <clipPath id="school_svg__a">
        <path fill="#fff" d="M1 4h22v16H1z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSchool;
